(function () {
  var regionData = [
    {
      title: 'Africa',
      eyebrow: 'Continental pride',
      detail: '54 countries represented',
      href: '/collections/africa',
      image: 'https://fahari.shop/cdn/shop/files/KenyaBeaded.jpg?v=1729118514&width=900'
    },
    {
      title: 'Caribbean',
      eyebrow: 'Island heritage',
      detail: '30+ islands and nations',
      href: '/collections/caribbean',
      image: 'https://fahari.shop/cdn/shop/files/Bahamas01.jpg?v=1729207803&width=900'
    },
    {
      title: 'North America',
      eyebrow: 'Everyday favorites',
      detail: '23 countries represented',
      href: '/collections/north-america',
      image: 'https://fahari.shop/cdn/shop/files/711Q2kZkHQL._SL1500_dcfb5d06-e31e-4b04-a032-054e348f7f1e.jpg?v=1729214177&width=900'
    },
    {
      title: 'Europe',
      eyebrow: 'Classic flag designs',
      detail: '40+ countries represented',
      href: '/collections/europe',
      image: 'https://fahari.shop/cdn/shop/files/DSC_7601.jpg?v=1765286018&width=900'
    },
    {
      title: 'South America',
      eyebrow: 'Bright color and pride',
      detail: '12 countries represented',
      href: '/collections/south-america',
      image: 'https://fahari.shop/cdn/shop/files/DSC_7627_d441c16d-dbe7-4709-91ee-9e0c88e854bc.jpg?v=1765360528&width=900'
    },
    {
      title: 'Asia & Middle East',
      eyebrow: 'Roots across regions',
      detail: '48+ countries represented',
      href: '/collections/asia',
      image: 'https://cdn.shopify.com/s/files/1/0682/1271/9765/files/India.jpg?v=1729120243'
    }
  ];

  var css = [
    '.fh-region-section{background:#f7f3ea!important;overflow:hidden!important}',
    '.fh-region-section .fh-section__head{margin-bottom:28px!important}',
    '.fh-region-grid{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:20px!important;overflow:visible!important;padding:0!important}',
    '.fh-region-card{position:relative!important;min-height:360px!important;border-radius:0!important;overflow:hidden!important;background:#111!important;color:#fff!important;text-decoration:none!important;box-shadow:0 18px 45px rgba(38,31,18,.12)!important}',
    '.fh-region-card__image{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:contain!important;object-position:center 38%!important;background:linear-gradient(180deg,#fff 0%,#f8f5ed 58%,#eae1d0 100%)!important;padding:32px 30px 118px!important;transform:none!important}',
    '.fh-region-card:after{content:""!important;position:absolute!important;inset:0!important;background:linear-gradient(180deg,rgba(0,0,0,0) 34%,rgba(0,0,0,.22) 58%,rgba(0,0,0,.82) 100%)!important;z-index:1!important;pointer-events:none!important}',
    '.fh-region-card__content{position:absolute!important;z-index:2!important;left:0!important;right:0!important;bottom:0!important;display:block!important;padding:22px 24px 24px!important}',
    '.fh-region-card__eyebrow{display:block!important;color:#d6ad4b!important;font-size:11px!important;font-weight:800!important;letter-spacing:.16em!important;text-transform:uppercase!important;margin-bottom:8px!important}',
    '.fh-region-card__title{display:block!important;color:#fff!important;font-size:clamp(26px,2.35vw,36px)!important;line-height:1!important;font-weight:800!important;letter-spacing:0!important;margin:0 54px 8px 0!important;text-transform:none!important}',
    '.fh-region-card__countries{display:block!important;color:rgba(255,255,255,.88)!important;font-size:14px!important;line-height:1.45!important}',
    '.fh-region-card__explore{display:inline-block!important;margin-top:14px!important;color:#f1cd76!important;border-bottom:1px solid rgba(241,205,118,.65)!important;font-size:13px!important;font-weight:800!important;letter-spacing:0!important;text-transform:none!important}',
    '.fh-region-card__arrow{position:absolute!important;z-index:3!important;right:20px!important;bottom:22px!important;width:46px!important;height:46px!important;border-radius:50%!important;background:#fff!important;color:#111!important;border:0!important;display:grid!important;place-items:center!important;font-size:22px!important;box-shadow:0 8px 20px rgba(0,0,0,.18)!important}',
    '.fh-region-card:hover .fh-region-card__image{transform:scale(1.025)!important}',
    '@media (max-width:990px){.fh-region-section{padding-top:46px!important}.fh-region-section .fh-container{width:100%!important;padding:0 18px!important}.fh-region-heading{font-size:48px!important;line-height:.95!important}.fh-region-intro{font-size:16px!important;line-height:1.55!important}.fh-region-section .fh-link{display:inline-block!important;margin-top:18px!important;font-size:16px!important}.fh-region-grid{display:grid!important;grid-template-columns:1fr!important;gap:16px!important;overflow:visible!important;scroll-snap-type:none!important}.fh-region-card{min-height:320px!important;width:100%!important;flex:none!important}.fh-region-card__image{padding:24px 22px 108px!important;object-position:center 34%!important}.fh-region-card__content{padding:20px!important}.fh-region-card__title{font-size:32px!important}.fh-region-card__countries{font-size:14px!important}.fh-region-card__arrow{width:44px!important;height:44px!important;right:18px!important;bottom:20px!important}}',
    '@media (min-width:991px) and (max-width:1240px){.fh-region-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important}}',
    '@media (max-width:749px){body:has(.localization-form__select[aria-expanded="true"]),body:has(.disclosure__button[aria-expanded="true"]){overflow:hidden!important}.localization-form__list,.disclosure__list,.country-selector__list,.localization-selector.link + .disclosure__list{max-height:min(62vh,560px)!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;padding-bottom:110px!important}.localization-form,.disclosure{max-height:calc(100vh - 130px)!important}.footer__localization,.lang__currency-desktop{position:relative!important;z-index:80!important}}'
  ].join('\n');

  function addStyle() {
    if (document.getElementById('fh-region-live-fix')) return;
    var style = document.createElement('style');
    style.id = 'fh-region-live-fix';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function updateRegions() {
    var cards = document.querySelectorAll('.fh-region-grid .fh-region-card');
    if (!cards.length) return;
    regionData.forEach(function (item, index) {
      var card = cards[index];
      if (!card) return;
      card.href = item.href;
      var img = card.querySelector('.fh-region-card__image');
      if (img) {
        img.src = item.image;
        img.alt = item.title + ' flag bracelet collection';
      }
      var eyebrow = card.querySelector('.fh-region-card__eyebrow');
      var title = card.querySelector('.fh-region-card__title');
      var countries = card.querySelector('.fh-region-card__countries');
      var explore = card.querySelector('.fh-region-card__explore');
      if (eyebrow) eyebrow.textContent = item.eyebrow;
      if (title) title.textContent = item.title;
      if (countries) countries.textContent = item.detail;
      if (explore) explore.textContent = 'Explore ' + item.title + ' bracelets ->';
    });
  }

  function run() {
    addStyle();
    updateRegions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('pageshow', run);
})();
